export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Electric-grill_icon" transform="translate(0.440662, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="r" transform="translate(1.772043, 7.036141)" stroke="#FFFFFF">
                        <path
                            d="M32.3586103,23.9277185 L2.09730439,23.9277185 C0.938893265,23.9277185 0,22.9819339 0,21.8150201 L0,2.11269846 C0,0.946488911 0.938893265,0 2.09730439,0 L32.3586103,0 C33.5170214,0 34.4559147,0.946488911 34.4559147,2.11269846 L34.4559147,21.8150201 C34.4559147,22.9819339 33.5170214,23.9277185 32.3586103,23.9277185 Z"
                            id="Stroke-257"
                            strokeWidth="1.29133719"
                        ></path>
                        <path
                            d="M30.196502,15.3137399 L4.25941267,15.3137399 C3.49249491,15.3137399 2.87132622,14.6939429 2.87132622,13.9302645 L2.87132622,3.7762472 C2.87132622,3.01256881 3.49249491,2.39277185 4.25941267,2.39277185 L30.196502,2.39277185 C30.9627257,2.39277185 31.5845885,3.01256881 31.5845885,3.7762472 L31.5845885,13.9302645 C31.5845885,14.6939429 30.9627257,15.3137399 30.196502,15.3137399 Z"
                            id="Stroke-258"
                            strokeWidth="1.29133719"
                        ></path>
                        <path
                            d="M32.3586103,17.7065117 L2.09730439,17.7065117 C0.938893265,17.7065117 0,16.7594094 0,15.5908699 L0,2.11564183 C0,0.947102327 0.938893265,0 2.09730439,0 L32.3586103,0 C33.5170214,0 34.4559147,0.947102327 34.4559147,2.11564183 L34.4559147,15.5908699 C34.4559147,16.7594094 33.5170214,17.7065117 32.3586103,17.7065117 Z"
                            id="Stroke-259"
                            strokeWidth="1.29133719"
                        ></path>
                        <line
                            x1="5.98192963"
                            y1="4.28199084"
                            x2="5.98192963"
                            y2="13.4245209"
                            id="Stroke-260"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="8.85325586"
                            y1="4.28199084"
                            x2="8.85325586"
                            y2="13.4245209"
                            id="Stroke-261"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="11.7245821"
                            y1="4.28199084"
                            x2="11.7245821"
                            y2="13.4245209"
                            id="Stroke-262"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="14.5959083"
                            y1="4.28199084"
                            x2="14.5959083"
                            y2="13.4245209"
                            id="Stroke-263"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="17.4672345"
                            y1="4.28199084"
                            x2="17.4672345"
                            y2="13.4245209"
                            id="Stroke-264"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="19.8600064"
                            y1="4.28199084"
                            x2="19.8600064"
                            y2="13.4245209"
                            id="Stroke-265"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="22.7313326"
                            y1="4.28199084"
                            x2="22.7313326"
                            y2="13.4245209"
                            id="Stroke-266"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="25.6026588"
                            y1="4.28199084"
                            x2="25.6026588"
                            y2="13.4245209"
                            id="Stroke-267"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="28.4739851"
                            y1="4.28199084"
                            x2="28.4739851"
                            y2="13.4245209"
                            id="Stroke-268"
                            strokeWidth="0.957108742"
                            strokeLinecap="round"
                        ></line>
                        <path
                            d="M5.74265245,20.3385608 C5.74265245,20.4704458 5.635626,20.5778379 5.50313952,20.5778379 C5.37112452,20.5778379 5.26409808,20.4704458 5.26409808,20.3385608 C5.26409808,20.2066757 5.37112452,20.0992836 5.50313952,20.0992836 C5.635626,20.0992836 5.74265245,20.2066757 5.74265245,20.3385608 Z"
                            id="Stroke-269"
                            strokeWidth="0.759610112"
                            fill="#FFFFFF"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M10.0496418,20.3385608 C10.0496418,20.4704458 9.94261534,20.5778379 9.81060034,20.5778379 C9.67811386,20.5778379 9.57108742,20.4704458 9.57108742,20.3385608 C9.57108742,20.2066757 9.67811386,20.0992836 9.81060034,20.0992836 C9.94261534,20.0992836 10.0496418,20.2066757 10.0496418,20.3385608 Z"
                            id="Stroke-270"
                            strokeWidth="0.759610112"
                            fill="#FFFFFF"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M25.3633817,20.3385608 C25.3633817,20.4704458 25.2559895,20.5778379 25.1241045,20.5778379 C24.9922194,20.5778379 24.8848273,20.4704458 24.8848273,20.3385608 C24.8848273,20.2066757 24.9922194,20.0992836 25.1241045,20.0992836 C25.2559895,20.0992836 25.3633817,20.2066757 25.3633817,20.3385608 Z"
                            id="Stroke-271"
                            strokeWidth="0.759610112"
                            fill="#FFFFFF"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M29.670371,20.3385608 C29.670371,20.4704458 29.5633445,20.5778379 29.4308581,20.5778379 C29.2988431,20.5778379 29.1918166,20.4704458 29.1918166,20.3385608 C29.1918166,20.2066757 29.2988431,20.0992836 29.4308581,20.0992836 C29.5633445,20.0992836 29.670371,20.2066757 29.670371,20.3385608 Z"
                            id="Stroke-272"
                            strokeWidth="0.759610112"
                            fill="#FFFFFF"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M18.843102,20.8171151 C18.843102,21.5766714 18.2271865,22.1929826 17.4669796,22.1929826 C16.7072825,22.1929826 16.0913671,21.5766714 16.0913671,20.8171151 C16.0913671,20.057049 16.7072825,19.4412477 17.4669796,19.4412477 C18.2271865,19.4412477 18.843102,20.057049 18.843102,20.8171151 Z"
                            id="Stroke-273"
                            strokeWidth="0.81354243"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
